// 公共常量
export default {
  // CDN 域名，用于存储图片等静态资源，加快加载速度，css 中无法使用变量，所以css中暂时先写死
  CDN_URL: 'https://cdn.smsat.space',
  ATK_DOC: 'https://atkdoc.smsat.space',
  CONTACTS: `- 电子邮箱： atk_service@163.com
  - 手机/微信： 16670175501`
}


// WEBPACK FOOTER //
// ./src/utils/globalVal.js